export class RackPositionIdRequest{
    plantId: number;
    zoneId: number;
    rackId: number;
    rackPositionId: number;
    isReserved: boolean;
    updatedUser: string;
    saleOrderId: number;
    varientId: number;
    
    constructor(plantId: number,
        zoneId: number,rackId:number,rackPositionId: number,isReserved: boolean,
        updatedUser: string,saleOrderId: number,varientId:number){
        this.plantId = plantId;
        this.zoneId = zoneId;
        this.rackId = rackId;
        this.rackPositionId = rackPositionId;
        this.isReserved = isReserved;
        this.updatedUser = updatedUser;
        this.saleOrderId = saleOrderId;
        this.varientId = varientId;
    }
}